// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleNotes-module__headerRow___DxsC6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 20px;
}

.HuddleNotes-module__header___YVvAB {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #71717a;
}

.HuddleNotes-module__headerMeta___Yio5h {
  font-size: 14px;
  color: #71717a;
}

.HuddleNotes-module__threadRow___GxyGB {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 20px;
  background: #fafafa;
}

.HuddleNotes-module__note___oUU07 {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.HuddleNotes-module__avatar___A6FHQ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-top: 2px;
  border-radius: 999px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  background: #18181b;
}

.HuddleNotes-module__noteBody___NNHW1 {
  min-width: 0;
  flex: 1;
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.HuddleNotes-module__noteText___qV_VX {
  font-size: 15px;
  color: #18181b;
  white-space: pre-wrap;
}

.HuddleNotes-module__noteMetaRow___Q6qGV {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
}

.HuddleNotes-module__noteMeta___P9Eg1 {
  font-size: 13px;
  color: #71717a;
}

.HuddleNotes-module__editButton___VyEOX {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
}

.HuddleNotes-module__editButton___VyEOX:hover {
  background: #f4f4f5;
}

.HuddleNotes-module__editButtons___B81ai {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.HuddleNotes-module__composerRow____eLhR {
  padding: 16px 20px;
}

.HuddleNotes-module__composer___NG_YT {
  width: 100%;
  min-height: 64px;
  padding: 8px 10px;
  font-size: 14px;
  font-family: inherit;
  color: #18181b;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  resize: vertical;
}

.HuddleNotes-module__composerButtons___wgWd4 {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.HuddleNotes-module__postButton___rXixw {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #18181b;
  cursor: pointer;
}

.HuddleNotes-module__postButton___rXixw:hover:not(:disabled) {
  background: #f4f4f5;
}

.HuddleNotes-module__postButton___rXixw:disabled {
  color: #a1a1aa;
  cursor: not-allowed;
}

.HuddleNotes-module__subtitle___qdA5Y {
  margin: 0;
  padding: 0 20px 12px;
  font-size: 13px;
  color: #71717a;
}

.HuddleNotes-module__sourceTag___UkGcp {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f4f4f5;
  font-size: 12px;
  font-weight: 500;
  color: #52525b;
}

.HuddleNotes-module__editActionButton___J_phV {
  padding: 4px 12px;
}

.HuddleNotes-module__saveButton___JAcfR,
.HuddleNotes-module__saveButton___JAcfR:hover:not(:disabled) {
  border-color: #18181b;
  background: #18181b;
  color: #ffffff;
}

.HuddleNotes-module__saveButton___JAcfR:hover:not(:disabled) {
  background: #27272a;
}

.HuddleNotes-module__saveButton___JAcfR:disabled {
  border-color: #e4e4e7;
  background: #f4f4f5;
  color: #a1a1aa;
}

.HuddleNotes-module__panelHeaderRow___zZDgF {
  align-items: baseline;
  padding: 16px 20px 4px;
}

.HuddleNotes-module__panelTitle___UYghy {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: #18181b;
}

.HuddleNotes-module__panelSubtitle___dOqTT {
  padding-bottom: 14px;
}

.HuddleNotes-module__panelThreadRow___Y7_lc {
  padding: 12px 20px;
  border-top: 1px solid #f4f4f5;
  border-bottom: 1px solid #f4f4f5;
}

.HuddleNotes-module__emptyText___vT1kg {
  margin: 0;
  font-size: 13px;
  color: #a1a1aa;
}

.HuddleNotes-module__composerLabel___WOlND {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #71717a;
}

.HuddleNotes-module__countBadge___yesna {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e4e4e7;
  background: #fafafa;
  font-size: 11px;
  font-weight: 500;
  color: #52525b;
}

.HuddleNotes-module__summarySection___Q1_eO {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid #f4f4f5;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.HuddleNotes-module__summarySection___Q1_eO:hover {
  background: #fafafa;
}

.HuddleNotes-module__summarySection___Q1_eO:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.HuddleNotes-module__summaryEmpty___zbeuu {
  margin: 0;
  font-size: 13px;
  color: #a1a1aa;
}

.HuddleNotes-module__summaryHeader___dBRhH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.HuddleNotes-module__summaryLabel___w9D_4 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #71717a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.HuddleNotes-module__summaryCount____Nv69 {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 500;
  color: #71717a;
}

.HuddleNotes-module__summaryList___WuRWn {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.HuddleNotes-module__summaryNote___qfEmS {
  padding-left: 10px;
  border-left: 2px solid #e4e4e7;
}

.HuddleNotes-module__summaryText___QLJpe {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #27272a;
  white-space: pre-wrap;
}

.HuddleNotes-module__summaryMeta___Vu7QO {
  margin: 2px 0 0;
  font-size: 11px;
  color: #a1a1aa;
}

.HuddleNotes-module__summaryMore___yTplB {
  margin: 6px 0 0;
  font-size: 12px;
  font-weight: 500;
  color: #71717a;
}

.HuddleNotes-module__backBar___bf8mt {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.HuddleNotes-module__backBar___bf8mt:hover {
  background: #f4f4f5;
  border-color: #a1a1aa;
}

.HuddleNotes-module__backBar___bf8mt:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.HuddleNotes-module__backArrow___6GhQx {
  color: #a1a1aa;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
}

.HuddleNotes-module__backBody___oiQGf {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.HuddleNotes-module__backLabel___xdySd {
  font-size: 12px;
  font-weight: 600;
  color: #a1a1aa;
  line-height: 1.2;
}

.HuddleNotes-module__backTitle___SaVqL {
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.HuddleNotes-module__panelCard___IetjU {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.HuddleNotes-module__visitLabel___Nk6Cx {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #71717a;
}

.HuddleNotes-module__visitLabel___Nk6Cx:not(:first-child) {
  margin-top: 6px;
}

.HuddleNotes-module__composerVisit___HCmQ0 {
  font-weight: 500;
  letter-spacing: normal;
  text-transform: none;
  color: #a1a1aa;
}

.HuddleNotes-module__compact___mE3j4 .HuddleNotes-module__avatar___A6FHQ {
  width: 24px;
  height: 24px;
}

.HuddleNotes-module__compact___mE3j4 .HuddleNotes-module__noteBody___NNHW1 {
  padding: 8px 12px;
}

.HuddleNotes-module__compact___mE3j4 .HuddleNotes-module__noteText___qV_VX {
  font-size: 14px;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleNotes/HuddleNotes.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,OAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,6BAAA;EACA,gCAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,0BAAA;EACA,oBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,8BAAA;AACF;;AAEA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gEACE;AAAJ;;AAIA;EACE,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE,0BAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF","sourcesContent":[".headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 16px 20px;\n}\n\n.header {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.headerMeta {\n  font-size: 14px;\n  color: #71717a;\n}\n\n.threadRow {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px 20px;\n  background: #fafafa;\n}\n\n.note {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  margin-top: 2px;\n  border-radius: 999px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n  background: #18181b;\n}\n\n.noteBody {\n  min-width: 0;\n  flex: 1;\n  padding: 10px 14px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.noteText {\n  font-size: 15px;\n  color: #18181b;\n  white-space: pre-wrap;\n}\n\n.noteMetaRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.noteMeta {\n  font-size: 13px;\n  color: #71717a;\n}\n\n.editButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #52525b;\n  cursor: pointer;\n}\n\n.editButton:hover {\n  background: #f4f4f5;\n}\n\n.editButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.composerRow {\n  padding: 16px 20px;\n}\n\n.composer {\n  width: 100%;\n  min-height: 64px;\n  padding: 8px 10px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #18181b;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  resize: vertical;\n}\n\n.composerButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.postButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #18181b;\n  cursor: pointer;\n}\n\n.postButton:hover:not(:disabled) {\n  background: #f4f4f5;\n}\n\n.postButton:disabled {\n  color: #a1a1aa;\n  cursor: not-allowed;\n}\n\n.subtitle {\n  margin: 0;\n  padding: 0 20px 12px;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.sourceTag {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f4f4f5;\n  font-size: 12px;\n  font-weight: 500;\n  color: #52525b;\n}\n\n.editActionButton {\n  padding: 4px 12px;\n}\n\n.saveButton,\n.saveButton:hover:not(:disabled) {\n  border-color: #18181b;\n  background: #18181b;\n  color: #ffffff;\n}\n\n.saveButton:hover:not(:disabled) {\n  background: #27272a;\n}\n\n.saveButton:disabled {\n  border-color: #e4e4e7;\n  background: #f4f4f5;\n  color: #a1a1aa;\n}\n\n.panelHeaderRow {\n  align-items: baseline;\n  padding: 16px 20px 4px;\n}\n\n.panelTitle {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #18181b;\n}\n\n.panelSubtitle {\n  padding-bottom: 14px;\n}\n\n.panelThreadRow {\n  padding: 12px 20px;\n  border-top: 1px solid #f4f4f5;\n  border-bottom: 1px solid #f4f4f5;\n}\n\n.emptyText {\n  margin: 0;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.composerLabel {\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.countBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #e4e4e7;\n  background: #fafafa;\n  font-size: 11px;\n  font-weight: 500;\n  color: #52525b;\n}\n\n.summarySection {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: 0;\n  border-bottom: 1px solid #f4f4f5;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.summarySection:hover {\n  background: #fafafa;\n}\n\n.summarySection:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.summaryEmpty {\n  margin: 0;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.summaryHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.summaryLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #71717a;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.summaryCount {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #71717a;\n}\n\n.summaryList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.summaryNote {\n  padding-left: 10px;\n  border-left: 2px solid #e4e4e7;\n}\n\n.summaryText {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #27272a;\n  white-space: pre-wrap;\n}\n\n.summaryMeta {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.summaryMore {\n  margin: 6px 0 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #71717a;\n}\n\n.backBar {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.backBar:hover {\n  background: #f4f4f5;\n  border-color: #a1a1aa;\n}\n\n.backBar:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.backArrow {\n  color: #a1a1aa;\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.backBody {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.backLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #a1a1aa;\n  line-height: 1.2;\n}\n\n.backTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #52525b;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.panelCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.visitLabel {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.visitLabel:not(:first-child) {\n  margin-top: 6px;\n}\n\n.composerVisit {\n  font-weight: 500;\n  letter-spacing: normal;\n  text-transform: none;\n  color: #a1a1aa;\n}\n\n.compact .avatar {\n  width: 24px;\n  height: 24px;\n}\n\n.compact .noteBody {\n  padding: 8px 12px;\n}\n\n.compact .noteText {\n  font-size: 14px;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `HuddleNotes-module__headerRow___DxsC6`,
	"header": `HuddleNotes-module__header___YVvAB`,
	"headerMeta": `HuddleNotes-module__headerMeta___Yio5h`,
	"threadRow": `HuddleNotes-module__threadRow___GxyGB`,
	"note": `HuddleNotes-module__note___oUU07`,
	"avatar": `HuddleNotes-module__avatar___A6FHQ`,
	"noteBody": `HuddleNotes-module__noteBody___NNHW1`,
	"noteText": `HuddleNotes-module__noteText___qV_VX`,
	"noteMetaRow": `HuddleNotes-module__noteMetaRow___Q6qGV`,
	"noteMeta": `HuddleNotes-module__noteMeta___P9Eg1`,
	"editButton": `HuddleNotes-module__editButton___VyEOX`,
	"editButtons": `HuddleNotes-module__editButtons___B81ai`,
	"composerRow": `HuddleNotes-module__composerRow____eLhR`,
	"composer": `HuddleNotes-module__composer___NG_YT`,
	"composerButtons": `HuddleNotes-module__composerButtons___wgWd4`,
	"postButton": `HuddleNotes-module__postButton___rXixw`,
	"subtitle": `HuddleNotes-module__subtitle___qdA5Y`,
	"sourceTag": `HuddleNotes-module__sourceTag___UkGcp`,
	"editActionButton": `HuddleNotes-module__editActionButton___J_phV`,
	"saveButton": `HuddleNotes-module__saveButton___JAcfR`,
	"panelHeaderRow": `HuddleNotes-module__panelHeaderRow___zZDgF`,
	"panelTitle": `HuddleNotes-module__panelTitle___UYghy`,
	"panelSubtitle": `HuddleNotes-module__panelSubtitle___dOqTT`,
	"panelThreadRow": `HuddleNotes-module__panelThreadRow___Y7_lc`,
	"emptyText": `HuddleNotes-module__emptyText___vT1kg`,
	"composerLabel": `HuddleNotes-module__composerLabel___WOlND`,
	"countBadge": `HuddleNotes-module__countBadge___yesna`,
	"summarySection": `HuddleNotes-module__summarySection___Q1_eO`,
	"summaryEmpty": `HuddleNotes-module__summaryEmpty___zbeuu`,
	"summaryHeader": `HuddleNotes-module__summaryHeader___dBRhH`,
	"summaryLabel": `HuddleNotes-module__summaryLabel___w9D_4`,
	"summaryCount": `HuddleNotes-module__summaryCount____Nv69`,
	"summaryList": `HuddleNotes-module__summaryList___WuRWn`,
	"summaryNote": `HuddleNotes-module__summaryNote___qfEmS`,
	"summaryText": `HuddleNotes-module__summaryText___QLJpe`,
	"summaryMeta": `HuddleNotes-module__summaryMeta___Vu7QO`,
	"summaryMore": `HuddleNotes-module__summaryMore___yTplB`,
	"backBar": `HuddleNotes-module__backBar___bf8mt`,
	"backArrow": `HuddleNotes-module__backArrow___6GhQx`,
	"backBody": `HuddleNotes-module__backBody___oiQGf`,
	"backLabel": `HuddleNotes-module__backLabel___xdySd`,
	"backTitle": `HuddleNotes-module__backTitle___SaVqL`,
	"panelCard": `HuddleNotes-module__panelCard___IetjU`,
	"visitLabel": `HuddleNotes-module__visitLabel___Nk6Cx`,
	"composerVisit": `HuddleNotes-module__composerVisit___HCmQ0`,
	"compact": `HuddleNotes-module__compact___mE3j4`
};
module.exports = ___CSS_LOADER_EXPORT___;
